import map from 'lodash/map';
import { USER_TIERS_CATALOGUE, USER_TIER_SUM } from '../../constants';
import { api } from '../api';
import { GetUserTiersCatalogueResponse, GetUserTierSumResponse } from './types';

export const tiersSlice = api.injectEndpoints({
  endpoints: (build) => ({
    userTiersCatalogue: build.query<GetUserTiersCatalogueResponse, void>({
      query: () => `${USER_TIERS_CATALOGUE}`,
      transformResponse: (
        response: GetUserTiersCatalogueResponse,
        meta,
        arg
      ) => {
        if (response.data.length > 0) {
          const arr = response.data || [];
          return {
            data: map(arr, (item, index) => ({
              ...item,
              first: index === 0,
              last: index === arr.length - 1,
              lowerBound: index === 0 ? '0' : arr[index - 1].upperBound,
              upperBound:
                item.upperBound === '0'
                  ? arr[index - 1].upperBound
                  : item.upperBound
            }))
          };
        }
        return response;
      }
    }),
    userTierSum: build.query<GetUserTierSumResponse, void>({
      query: () => `${USER_TIER_SUM}`
    })
  }),

  overrideExisting: false
});

export const { useUserTierSumQuery, useUserTiersCatalogueQuery } = tiersSlice;
